<template>
  <div class="progress-wrap">
    <span>剩余</span>
    <div class="progress-block">
      <div class="progress-line">
        <i class="active" :style="{width: rate + '%'}"></i>
      </div>
      <span class="progress-number">{{ rate }}%</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['rate']
  }
</script>

<style lang="scss" scoped>
.progress-wrap {
  position: absolute;
  top: 310px;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #feef01;
  font-size: 36px;
}
.progress-block {
  position: relative;
  width: 278px;
  text-align: center;
  margin-left: 21px;
  .progress-line {
    width: 100%;
    height: 14px;
    border-radius: 7px;
    background-color: rgba(0,0,0,0.3);
    position: relative;
    display: inline-block;
    // display: flex;
    overflow: hidden;
    // border: 1px solid red; 
    box-shadow: 0 0 0 1PX rgba(0,0,0,0.3);
    .active {
      width: 57%;
      background: linear-gradient(90deg, #feef01 70%, #fff7cb 100%);
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 100%;
      border-radius: 7px;
      display: inline-block;
      &::before {
        content: '';
        width: 100%;
        height: 200%;
        background: url('../assets/img/light-progress.png') 0 0 / 100% 100% no-repeat;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: -15px;
      }
    }
  }
  .progress-number {
    position: absolute;
    left: 0;
    right: 0;
    top: -21px;
    margin: auto;
    font-size: 24px;
    color: #fff000;
    font-weight: bold;
  }
}
</style>